import React from 'react'

const ManageVideo = () => {
    return (
        <>
            <div class="alert alert-dismissible bg-light-danger d-flex flex-center flex-column py-10 px-10 px-lg-20 mb-10">
                <div className='fs-3x'>🚧</div>
                <div class="text-center">
                    <h5 class="fw-bold mb-5">Module Under Development</h5>
                    <div class="separator separator-dashed border-danger opacity-25 mb-5"></div>
                    <div class="mb-9 text-gray-900">
                        This section is currently under development. Please check back later.
                    </div>
                </div>
            </div>
        </>
    )
}

export default ManageVideo